import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import { computed, set } from '@ember/object';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { cached, tracked } from '@glimmer/tracking';
import { inject } from '@ember/service';
import { _saveAll, _safeReload, _sortedCustomFields } from '../lib/utility.js';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44;
let EventModel = (_dec = attr('boolean'), _dec2 = attr('string'), _dec3 = attr('boolean'), _dec4 = attr('boolean'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('boolean'), _dec8 = attr('string'), _dec9 = attr('string'), _dec0 = attr('string'), _dec1 = attr('string'), _dec10 = attr('boolean'), _dec11 = attr('boolean'), _dec12 = attr('number'), _dec13 = attr('number'), _dec14 = attr('number', {
  currency: true
}), _dec15 = attr('number', {
  currency: true
}), _dec16 = attr('string'), _dec17 = computed('_tmpOption', 'option'), _dec18 = attr('string'), _dec19 = attr('string'), _dec20 = belongsTo('event_state', {
  inverse: null,
  async: false
}), _dec21 = hasMany('event', {
  inverse: null,
  async: false
}), _dec22 = hasMany('contact', {
  inverse: null,
  async: true
}), _dec23 = hasMany('product', {
  inverse: null,
  async: true
}), _dec24 = hasMany('project', {
  inverse: null,
  async: true
}), _dec25 = hasMany('workhour', {
  inverse: null,
  async: true
}), _dec26 = hasMany('invoice', {
  inverse: null,
  async: true
}), _dec27 = hasMany('payment', {
  inverse: null,
  async: true
}), _dec28 = hasMany('reminder', {
  inverse: 'event',
  async: false
}), _dec29 = hasMany('custom_field', {
  inverse: null,
  async: false
}), _dec30 = hasMany('address', {
  inverse: null,
  async: false
}), _dec31 = hasMany('file', {
  inverse: null,
  async: true
}), _dec32 = attr('number', {
  defaultValue: 0
}), _dec33 = attr('number', {
  defaultValue: 0
}), _dec34 = attr('number', {
  defaultValue: 0
}), _dec35 = attr('number', {
  defaultValue: 0
}), _dec36 = attr('number', {
  defaultValue: 0
}), _dec37 = attr('number', {
  defaultValue: 0
}), _dec38 = attr('number', {
  defaultValue: 0
}), _dec39 = attr('number', {
  defaultValue: 0
}), _dec40 = hasMany('contact', {
  inverse: null,
  async: false
}), _dec41 = attr('boolean', {
  defaultValue: false
}), _class = class EventModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "log", _descriptor3, this);
    _initializerDefineProperty(this, "checked", _descriptor4, this);
    _initializerDefineProperty(this, "archivied", _descriptor5, this);
    _initializerDefineProperty(this, "created_at", _descriptor6, this);
    _initializerDefineProperty(this, "is_pacchetto", _descriptor7, this);
    _initializerDefineProperty(this, "is_dispo", _descriptor8, this);
    _initializerDefineProperty(this, "title", _descriptor9, this);
    _initializerDefineProperty(this, "description", _descriptor0, this);
    _initializerDefineProperty(this, "all_day", _descriptor1, this);
    _initializerDefineProperty(this, "start_date", _descriptor10, this);
    _initializerDefineProperty(this, "end_date", _descriptor11, this);
    _initializerDefineProperty(this, "color", _descriptor12, this);
    _initializerDefineProperty(this, "notes", _descriptor13, this);
    _initializerDefineProperty(this, "videocall", _descriptor14, this);
    _initializerDefineProperty(this, "is_group", _descriptor15, this);
    _initializerDefineProperty(this, "max_group", _descriptor16, this);
    _initializerDefineProperty(this, "players_number", _descriptor17, this);
    _initializerDefineProperty(this, "price", _descriptor18, this);
    _initializerDefineProperty(this, "cost", _descriptor19, this);
    _initializerDefineProperty(this, "option", _descriptor20, this);
    _initializerDefineProperty(this, "recursive_pattern", _descriptor21, this);
    _initializerDefineProperty(this, "recursive_rule", _descriptor22, this);
    _initializerDefineProperty(this, "event_state", _descriptor23, this);
    _initializerDefineProperty(this, "related_events", _descriptor24, this);
    _initializerDefineProperty(this, "contacts", _descriptor25, this);
    _initializerDefineProperty(this, "products", _descriptor26, this);
    _initializerDefineProperty(this, "projects", _descriptor27, this);
    _initializerDefineProperty(this, "workhours", _descriptor28, this);
    _initializerDefineProperty(this, "invoices", _descriptor29, this);
    _initializerDefineProperty(this, "payments", _descriptor30, this);
    _initializerDefineProperty(this, "reminders", _descriptor31, this);
    _initializerDefineProperty(this, "custom_fields", _descriptor32, this);
    _initializerDefineProperty(this, "addresses", _descriptor33, this);
    _initializerDefineProperty(this, "files", _descriptor34, this);
    _initializerDefineProperty(this, "total_files_number", _descriptor35, this);
    _initializerDefineProperty(this, "total_contacts_number", _descriptor36, this);
    _initializerDefineProperty(this, "total_products_number", _descriptor37, this);
    _initializerDefineProperty(this, "total_projects_number", _descriptor38, this);
    _initializerDefineProperty(this, "total_reminders_number", _descriptor39, this);
    _initializerDefineProperty(this, "total_workhours_number", _descriptor40, this);
    _initializerDefineProperty(this, "total_payments_number", _descriptor41, this);
    _initializerDefineProperty(this, "total_related_events_number", _descriptor42, this);
    _initializerDefineProperty(this, "current_users", _descriptor43, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor44, this);
  }
  get idArray() {
    return [this.id];
  }
  saveAll(model) {
    return _saveAll(model, this.session, 'events_all');
  }
  safeReload() {
    return _safeReload(this);
  }
  get option_json() {
    if (this._tmpOption) {
      return this._tmpOption;
    } else if (!this.option) {
      return null;
    }
    try {
      return JSON.parse(this.option);
    } catch (e) {
      this.log.error(e);
      return null;
    }
  }
  set option_json(value) {
    set(this, '_tmpOption', value);
  }
  get sorted_custom_fields() {
    let fields;
    try {
      fields = this.custom_fields;
    } catch {
      return [];
    }
    if (Array.isArray(fields)) {
      return _sortedCustomFields(fields, this.isDeleted);
    }
    if (fields && typeof fields.then === 'function') {
      return fields.then(resolvedFields => _sortedCustomFields(resolvedFields, this.isDeleted));
    }
    return [];
  }
  get total_due() {
    return (this.price ?? 0) - (this.cost ?? 0);
  }
  get label() {
    const {
      intl,
      session,
      start_date,
      end_date
    } = this;
    const timeZone = session?.me?.time_zone || 'Europe/Rome';
    const formatDate = date => date ? intl.formatDate(date, {
      timeZone
    }) : '';
    const formatTime = date => date ? intl.formatTime(date, {
      timeZone,
      hour: 'numeric',
      minute: 'numeric'
    }) : '';
    const start_date_formatted = formatDate(start_date);
    const start_hour_formatted = formatTime(start_date);
    const end_hour_formatted = formatTime(end_date);
    return `${start_date_formatted} ${start_hour_formatted} - ${end_hour_formatted}`;
  }
  get sub_label() {
    return this.title || this.intl.t('no title');
  }
  get status_name() {
    return this.event_state?.status_name;
  }
  get firstLetters() {
    const name = this.title || '';
    const words = name.trim().split(' ');
    const initials = words.filter(word => word.length > 0).slice(0, 3).map(word => word[0].toUpperCase()).join('');
    return initials || '-';
  }
  get firstLetter() {
    if (this.title && this.title.length > 0) {
      return this.title[0].toLowerCase();
    }
    return '';
  }
  get current_users_label() {
    return this.current_users.map(user => user.label).join(' ');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "log", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "checked", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "archivied", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "created_at", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "is_pacchetto", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "is_dispo", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "title", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "all_day", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "start_date", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "end_date", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "color", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "videocall", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "is_group", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "max_group", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "players_number", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "price", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "cost", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "option", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "option_json", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "option_json"), _class.prototype), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "recursive_pattern", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "recursive_rule", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "event_state", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "related_events", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "contacts", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "products", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "projects", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "workhours", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "invoices", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "payments", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "reminders", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "custom_fields", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "sorted_custom_fields", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sorted_custom_fields"), _class.prototype), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "addresses", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "files", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "total_files_number", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "total_contacts_number", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "total_products_number", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "total_projects_number", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "total_reminders_number", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "total_workhours_number", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "total_payments_number", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "total_related_events_number", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "current_users", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { EventModel as default };
//# sourceMappingURL=event.js.map
